/* tts-carousel — autoplay + arrows for .tts-carousel scroll-snap carousels.
 * Replaces Slick on the homepage. No jQuery, no library.
 * The carousels are fully usable without this file (native horizontal scroll);
 * this only adds autoplay and the prev/next buttons.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function itemStep(el) {
    var first = el.firstElementChild;
    if (!first) return el.clientWidth;
    var gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function maxScroll(el) {
    return el.scrollWidth - el.clientWidth;
  }

  function atEnd(el) {
    return el.scrollLeft >= maxScroll(el) - 2;
  }

  // Index-based stepping. Reading scrollLeft mid-animation gives fractional
  // positions (scroll-snap settles a few px off), so a tolerance check on the
  // raw offset misfires and the wrap never fires. Rounding to a slide index
  // first makes both directions deterministic.
  function currentIndex(el) {
    var s = itemStep(el);
    return s > 0 ? Math.round(el.scrollLeft / s) : 0;
  }

  // NOTE: the element carries `scroll-behavior: smooth` in CSS, and that wins
  // over scrollTo({behavior:'auto'}) — the wrap would animate all the way back
  // across every slide. Forcing scroll-behavior inline and assigning scrollLeft
  // directly is the only reliable way to get a true instant jump.
  function goTo(el, left, instant) {
    if (instant || reduceMotion) {
      var prior = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto';
      el.scrollLeft = left;
      el.style.scrollBehavior = prior;
    } else {
      el.scrollTo({ left: left, behavior: 'smooth' });
    }
  }

  function advance(el) {
    var s = itemStep(el);
    var target = (currentIndex(el) + 1) * s;
    // past the last scroll position -> wrap to the start, instantly so it
    // reads as a loop rather than a long rewind across every slide
    if (target > maxScroll(el) + 2) goTo(el, 0, true);
    else goTo(el, target, false);
  }

  function retreat(el) {
    var i = currentIndex(el);
    if (i <= 0) goTo(el, maxScroll(el), true);
    else goTo(el, (i - 1) * itemStep(el), false);
  }

  function wireArrows(el) {
    var id = el.getAttribute('data-carousel-id');
    if (!id) return;
    var group = document.querySelector('.tts-carousel-arrows[data-carousel-for="' + id + '"]');
    if (!group) return;
    var prev = group.querySelector('[data-dir="prev"]');
    var next = group.querySelector('[data-dir="next"]');

    if (prev) prev.addEventListener('click', function () { retreat(el); });
    if (next) next.addEventListener('click', function () { advance(el); });
  }

  function wireAutoplay(el) {
    var ms = parseInt(el.getAttribute('data-autoplay'), 10);
    if (!ms || reduceMotion) return;

    var timer = null;
    function start() { if (!timer) timer = setInterval(function () { advance(el); }, ms); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    // don't burn CPU animating a carousel that's scrolled out of view
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.2 }).observe(el);
    } else {
      start();
    }
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
  }

  function init() {
    document.querySelectorAll('.tts-carousel').forEach(function (el) {
      if (el.dataset.ttsInit) return;
      el.dataset.ttsInit = '1';
      wireArrows(el);
      wireAutoplay(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
